<template>
  <div class="biz-field">
    <div class="head">
      <h3>业务领域</h3>
      <span @click="() => clickMore(15)">查看更多</span>
    </div>

    <div class="list">
      <div
        v-for="item in listData"
        :key="item.title"
        :style="{
          background: `linear-gradient(to bottom, rgba(8, 57, 79, 0.4) 0%, rgba(8, 57, 79, 0.4) 100%),
          center / cover no-repeat url('${item.bgImg}')`,
        }"
        @click="() => clickMore(item.id)"
      >
        <img :src="item.showIcon" :alt="item.title" />
        <h4>{{ item.title }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';

export default {
  name: 'BizField',

  data() {
    return {
      listData: [
        {
          id: 17,
          title: '交通基础设施',
          bgImg: 'https://www.jchc.cn/storage/sjk/6367dee9-4af6-4c3f-8aab-bc4def1f5184.jpg',
          showIcon: 'https://www.jchc.cn/storage/sjk/3207f02a-6b36-4ac5-9e02-7d9d5d74007a.png',
        },
        {
          id: 18,
          title: '金融投资',
          bgImg: 'https://www.jchc.cn/storage/sjk/8cc7370d-44c9-40c4-b2de-b817e577bc6a.jpg',
          showIcon: 'https://www.jchc.cn/storage/sjk/5db8b3b4-c1e9-4066-88c6-0e3b24d04bbf.png',
        },
        {
          id: 19,
          title: '交通+',
          bgImg: 'https://www.jchc.cn/storage/sjk/d8b21765-daa2-4785-b297-4cac7d07b3bf.jpg',
          showIcon: 'https://www.jchc.cn/storage/sjk/6b10a204-8cc3-4dbf-9754-16e1031a4b1e.png',
        },
      ],
      clickTag1: codes.MENU, // 标记点击的是菜单
      clickTag2: codes.ARTICLE, // 标记点击的是新闻文章
    };
  },

  methods: {
    // 点击更多跳转到当前栏目
    clickMore(menuId) {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        menuId,
      };
      this.$api.getMenuLevels(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, data, this.clickTag1),
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.biz-field {
  margin-top: 100px;

  .head {
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 56px;
    h3 {
      font-size: 42px;
      font-weight: 500;
      color: #333333;
      line-height: 59px;
    }
    > span {
      font-size: 26px;
      font-weight: 400;
      color: #adadad;
      line-height: 37px;
    }
  }

  .list {
    height: 594px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    > div {
      padding-top: 104px;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 67px;
      }

      h4 {
        height: 276px;
        width: 40px;
        font-size: 30px;
        font-weight: 500;
        color: #ffffff;
        line-height: 38px;
        margin-top: 50px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/BizField.vue